import { RecipCompressorAnimatic } from '@crossnokaye/ux-animatics';

import { Ref } from '@repo/sdk/models/components';

import {
  ANIMATIC_PRIMARY_LABEL,
  ANIMATIC_SECONDARY_LABEL,
} from '@/features/equipment-browser/animatics/constants';
import { getLabel } from '@/features/equipment-browser/animatics/helpers';
import { getRefValue } from '@/features/equipment-browser/utils';

import { AnimaticConfigProps } from './types';
import { ScaledAnimatic } from '../scaled-animatic';

export const AnimaticRecipCompressor = ({
  config,
  labels,
  state,
  className,
}: AnimaticConfigProps) => {
  const pistonOnRefs = config.specificAnimaticConfig?.recipCompressor?.pistonOnRefs ?? [];
  const isTrim = config.specificAnimaticConfig?.recipCompressor?.isTrim ?? false;
  let pistonOnValues = [];
  if (pistonOnRefs.length === 0) {
    pistonOnValues = [false, false];
  } else {
    pistonOnValues = pistonOnRefs.map((ref: Ref) => getRefValue(ref) as boolean);
  }
  const primaryLabel = getLabel(labels, ANIMATIC_PRIMARY_LABEL);
  const secondaryLabel = getLabel(labels, ANIMATIC_SECONDARY_LABEL);

  return (
    <ScaledAnimatic className={className} scaleX={1} scaleY={1}>
      <RecipCompressorAnimatic
        isService={false}
        isTrim={isTrim}
        metricLabel={primaryLabel?.text}
        pistonOn={pistonOnValues}
        state={state}
        typeLabel={secondaryLabel?.text}
      />
    </ScaledAnimatic>
  );
};
